module.exports = __webpack_public_path__ + "static/media/3-en.998bfc19.jpg";